import _defineProperty from "/usr/src/app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "/usr/src/app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["tag", "toggle", "styles", "disabled", "header", "footer", "divider", "onClick", "active", "href"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React, { memo, useContext, useCallback } from 'react';
import classNames from 'classnames';
import { applyStylingHoc } from '../../lib/styling.js';
import baseStyles from './Dropdown.scss';
import { DropdownContext } from './Dropdown.js';
export var DropdownItem = function DropdownItem(_ref) {
  var _ref$tag = _ref.tag,
      tag = _ref$tag === void 0 ? 'button' : _ref$tag,
      _ref$toggle = _ref.toggle,
      toggle = _ref$toggle === void 0 ? true : _ref$toggle,
      _ref$styles = _ref.styles,
      styles = _ref$styles === void 0 ? {} : _ref$styles,
      disabled = _ref.disabled,
      header = _ref.header,
      footer = _ref.footer,
      divider = _ref.divider,
      onClick = _ref.onClick,
      active = _ref.active,
      href = _ref.href,
      rest = _objectWithoutProperties(_ref, _excluded);

  var context = useContext(DropdownContext);
  var onClickHandle = useCallback(function (e) {
    if (disabled || header || footer || divider) {
      e.preventDefault();
      return;
    }

    if (onClick) {
      onClick(e);
    }

    if (toggle) {
      context.toggle(e);
    }
  }, [onClick, disabled, header, footer, divider, toggle, context]);

  var getTabIndex = function getTabIndex() {
    if (disabled || header || footer || divider) {
      return '-1';
    }

    return '0';
  };

  var tabIndex = getTabIndex();
  var Tag = tag;
  var classes = classNames(disabled && styles['is-disabled'], !divider && !header && !footer && styles.item, active && styles['is-active'], header && styles.header, footer && styles.footer, divider && styles.divider);

  if (Tag === 'button') {
    if (header) {
      Tag = 'h6';
    } else if (footer) {
      Tag = 'div';
    } else if (divider) {
      Tag = 'div';
    } else if (href) {
      Tag = 'a';
    }
  }

  return React.createElement(Tag, _objectSpread(_objectSpread({
    type: Tag === 'button' && (onClick || toggle) ? 'button' : undefined,
    disabled: disabled,
    href: href
  }, rest), {}, {
    tabIndex: tabIndex,
    className: classes,
    onClick: onClickHandle
  }));
};
export default applyStylingHoc(baseStyles)(memo(DropdownItem));